// extracted by mini-css-extract-plugin
module.exports = {"socials__container":"Socials_socials__container__xpXBX","socials__item":"Socials_socials__item__SMeEK"};